import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GENERIC_ERROR } from '../util/constantes-mensajes';
import { AuthService } from './auth.service';
@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const user = this.authService.user;
        if (user && !req.url.includes(environment.firebaseConfig.apiUrl) && !req.url.includes(environment.genIA.iaURL)) {
            req = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + user.token) });
            return next.handle(req).pipe(catchError((err) => this.handleRefreshToken(err, req, next)));
        }
        return next.handle(req);
    }

    private handleError(err: HttpErrorResponse): Observable<any> {
        const error = {
            error: { message: GENERIC_ERROR },
        };
        console.error(err)
        return throwError(() => (err?.error.message ? err : error));
    }

    private handleRefreshToken(err: HttpErrorResponse, req: HttpRequest<any>, next: HttpHandler) {
        if (err.error.statusCode === 401) {
            return this.authService.refreshToken().pipe(
                switchMap((data) => {
                    const newReq = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + data.idToken) });
                    return next.handle(newReq);
                })
            );
        } else {
            return this.handleError(err);
        }
    }
}
